module.exports = __webpack_public_path__ + "img/a3.1d29edbd.png";